module.exports = __webpack_public_path__ + "static/media/Formstack_Sign_Product_Logo_Mono_Rev.f39e9774.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Formstack_Sign_Product_Logo_Mono_Rev.svg
// module id = 657
// module chunks = 0